import { render, staticRenderFns } from "./youtube-authorize.vue?vue&type=template&id=d3ff0bc6&scoped=true&"
import script from "./youtube-authorize.vue?vue&type=script&lang=js&"
export * from "./youtube-authorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ff0bc6",
  null
  
)

export default component.exports